import React, { Component } from 'react';
import NormalLink from './NormalLink';
import AccessControl from "../PermissionLocks/AccessControl";
import {getQcCount} from "../../redux/admin/AppReducer";
import {connect} from "react-redux";

const displayStyle = { display: 'block'};
const noDisplayStyle = { display: 'none'};

const URL_TO_COUNT = {
    "/manager/venue/content-quality-list/preqc": 'pre_qc_total_count',
    "/manager/venue/content-quality-list/qc": 'qc_total_count',
    "/manager/venue/content-quality-list/reject_qc": 'rejected_qc_total_count',
    "/manager/venue/content-quality-list/required_qc": 'required_qc_again_total_count',
}

export class DropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    };

    convertCountData (url) {
        return URL_TO_COUNT[url] !== undefined ? URL_TO_COUNT[url] : null;
    }

    getTabCount (url) {
        let count = this?.props?.count[0];
        let key = this.convertCountData(url);
        if(count?.[key]) {
            return count[key];
        }
    }

    componentDidMount () {
        let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
        if (activeUrlList && activeUrlList.length > 0) {
            this.setState({
                isOpen: true
            });
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.activeUrl !== this.props.activeUrl) {
            let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
            if (activeUrlList && activeUrlList.length > 0) {
                this.setState({
                    isOpen: true
                });
            }
        }
    };

    getBlockClass = () => {
        let text = 'hasChild';
        let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
        if (activeUrlList && activeUrlList.length > 0) {
            text += 'open active';
        } else if (this.state.isOpen) {
            text += ' open';
        }
        return text;
    };

    toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    render() {
        return (
            <li className={this.getBlockClass()} onClick={() => this.toggleOpen()}>
                <a><i className={this.props.icon} /><span>{this.props.name}</span></a>
                <ul className="acc-menu" style={this.state.isOpen ? displayStyle : noDisplayStyle}>
                    {this.props.list.map((item) => (
                        <AccessControl
                            userPermissions={this.props.userPermissions}
                            shouldHavePermissions={item.shouldHavePermissions ? item.shouldHavePermissions : []}
                        >
                            <NormalLink
                                count={this.getTabCount(item.url)}
                                key={item.url}
                                url={item.url}
                                name={item.name}
                                icon={item.icon}
                                activeUrl={window && window.location ? window.location.pathname : null}
                            />
                        </AccessControl>
                    ))}
                </ul>
            </li>
        );
    }
}

function mapStateToProps (state) {
    return {
        count: getQcCount(state)
    }
}

export default connect(mapStateToProps)(DropDown);

